<h2 mat-dialog-title>Select {{ 'LABEL.DOCTORS' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'LABEL.DOCTORS' | translate }}</mat-label>
    <mat-select [formControl]="doctorControl">
      <mat-option *ngFor="let doc of doctorslist" [value]="doc.id">
        {{ doc.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

